export interface GetBibliographyRealReserveSetGroupRequest {
  id: number
}

export function GetBibliographyRealReserveSetGroupRequestToJSON(
  value: GetBibliographyRealReserveSetGroupRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
